import React from 'react';

import LinkIconButton, { type LinkIconButtonProps } from '@atlaskit/button/icon/link';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';

const tooltipOptions: LinkIconButtonProps['tooltip'] = {
	position: 'right',
	hideTooltipOnClick: true,
};

const LinkIconButtonTooltipOptionsExample = (): React.JSX.Element => {
	return (
		<LinkIconButton
			href="https://atlassian.com"
			icon={PersonAvatarIcon}
			label="View profile"
			isTooltipDisabled={false}
			tooltip={tooltipOptions}
		/>
	);
};

export default LinkIconButtonTooltipOptionsExample;
